<div class="no-item-message">{{ message() }}</div>
